export const MUTATION_DELETE_MPB_CASE = /* GraphQL */ `
	mutation ($id: String!) {
		deleteMietpreisbremseCase(id: $id)
	}
`;
